import { render, staticRenderFns } from "./issuable.vue?vue&type=template&id=6adc5550&"
import script from "./issuable.vue?vue&type=script&lang=js&"
export * from "./issuable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports